module.exports = __webpack_public_path__ + "img/gpt.3e3d8390.svg";